import { push } from 'connected-react-router'
import { createAction } from 'redux-actions'
import Popup from 'react-popup'
import {
  LOGIN_USER,
  LOGOUT_USER,
  SELECT_WORKCENTER_REQUIRED,
  SWITCH_WORKCENTER_REQUESTED,
  TALLY_REQUIRED,
  TALLY_CANCELLED,
  LOGIN_USER_ERROR,
  GET_CONFIG,
  SET_LANG,
  API_ERROR
} from '../constants/ActionTypes'
import Odoo from '../utils/Odoo'
import { setQueries } from '../utils/Tools'
import { api_error } from './ProductionActions'

export const logUserOut = createAction(LOGOUT_USER)
export const cancelTally = createAction(TALLY_CANCELLED)

export function selectLang(lang) {
  const query = setQueries({ lang })
  return dispatch => {
    dispatch({ type: SET_LANG, payload: lang })
    dispatch(push({ search: query }))
  }
}

function completeLogin(dispatch, session) {
  Odoo.call('production/get_config', {}, session.token).then(config => {
    dispatch({ type: GET_CONFIG, payload: { ...config } })
    dispatch({ type: LOGIN_USER, payload: { ...session } })
    dispatch(selectLang((session.lang === 'pl_PL') ? 'pl-PL' : 'en-US'))
    if (session.warning) {
      Popup.alert(session.warning)
    }
  }).catch(error => {
    dispatch({ type: API_ERROR, message: error.message })
  })
}

export function logUserIn(login, password) {
  return dispatch => {
    Odoo.login('production/login', { login, password }).then(result => {
      if (result.token) {
        completeLogin(dispatch, result)
      } else {
        dispatch({ type: SELECT_WORKCENTER_REQUIRED, payload: {
          pendingToken: result.pending_token,
          workcenters: result.workcenters
        } })
      }
    }).catch(error => {
      dispatch({ type: LOGIN_USER_ERROR, message: error.message })
    })
  }
}

export function switchWorkcenter() {
  return dispatch => {
    dispatch({ type: SWITCH_WORKCENTER_REQUESTED })
    dispatch(push('/login'))
  }
}

export function selectWorkcenter(workcenter_id, qtyProduced, qtyWaste) {
  return (dispatch, getState) => {
    const pendingToken = getState().auth.pendingToken
    const params = { workcenter_id }
    if (qtyProduced !== undefined) {
      params.qty_produced = qtyProduced
      params.qty_waste = qtyWaste || 0
    }
    Odoo.call('production/select_workcenter', params, pendingToken).then(result => {
      if (result.status === 'tally_required') {
        dispatch({ type: TALLY_REQUIRED,
          payload: { mode: 'switch', operation: result.operation, workcenterId: workcenter_id } })
      } else {
        completeLogin(dispatch, result)
      }
    }).catch(error => {
      dispatch({ type: LOGIN_USER_ERROR, message: error.message })
    })
  }
}

export function confirmSwitchWorkcenter(qtyProduced, qtyWaste) {
  return (dispatch, getState) => {
    const { pendingSwitchWorkcenterId } = getState().auth
    dispatch(selectWorkcenter(pendingSwitchWorkcenterId, qtyProduced, qtyWaste))
  }
}

export function requestLogout() {
  return dispatch => {
    Odoo.call('production/logout', {}).then(result => {
      if (result.status === 'tally_required') {
        dispatch({ type: TALLY_REQUIRED, payload: { mode: 'logout', operation: result.operation } })
      } else {
        dispatch(logUserOut())
      }
    }).catch(error => api_error(dispatch, error))
  }
}

export function confirmLogout(qtyProduced, qtyWaste) {
  return dispatch => {
    const params = { qty_produced: qtyProduced, qty_waste: qtyWaste || 0 }
    Odoo.call('production/logout', params).then(() => {
      dispatch(logUserOut())
    }).catch(error => api_error(dispatch, error))
  }
}
